import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "I",
    title: "The Dubai Gateway & GCC Supply Chain",
    body: "From our head office at Ontario Tower, Business Bay, ATS Textile Trading LLC sits at the crossroads of global garment trade. Dubai's ports, free zones and air corridors let us move consolidated wholesale consignments across the UAE, Saudi Arabia, Kuwait, Qatar, Bahrain and Oman in days — not weeks.",
  },
  {
    num: "II",
    title: "Fabric Craft & Artisanal Sourcing",
    body: "Every lot we trade is hand-inspected: Japanese high-density weaves for desert climates, Italian linens, combed cottons and fluid silks. We source directly from mills and ateliers so retailers receive consistent hand-feel, colourfastness and finish — season after season.",
  },
  {
    num: "III",
    title: "Institutional B2B Reliability & Custom OEM",
    body: "Retail chains, department stores and distributors rely on us for private label manufacturing, custom dyeing, and flexible bulk payment terms. One account manager, transparent MOQs, and samples dispatched before any commitment — that is the ATS way of doing business.",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-manifesto-section" className="py-20 lg:py-32 px-4 sm:px-8 lg:px-16 bg-[#0A0B0E]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#D4AF37]/80 mb-4">About Us — A Manifesto in Three Chapters</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-snug max-w-3xl">
            Woven in Dubai. <span className="italic text-gold-gradient">Traded across the region.</span>
          </h2>
        </motion.div>

        <div className="mt-16 lg:mt-24 space-y-0">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`about-chapter-${i + 1}`}
              className={`grid lg:grid-cols-12 gap-6 lg:gap-10 py-12 lg:py-16 border-t border-[#D4AF37]/15 ${
                i % 2 === 1 ? "lg:text-right" : ""
              }`}
            >
              <div className={`lg:col-span-3 ${i % 2 === 1 ? "lg:order-3" : ""}`}>
                <span className="font-display text-6xl lg:text-7xl text-[#D4AF37]/25">Chapter {c.num}</span>
              </div>
              <div className="lg:col-span-4">
                <h3 className="font-display text-2xl lg:text-3xl text-amber-100 leading-snug">{c.title}</h3>
              </div>
              <div className="lg:col-span-5">
                <p className="text-base sm:text-lg font-light leading-relaxed text-slate-300">{c.body}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
